module.exports = __webpack_public_path__ + "static/media/ios-qr-scanner.dee768e1.svg";